var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGoogleSymbol = function SvgGoogleSymbol(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.3599,
    height: 19.3076,
    viewBox: "0 0 18.3599 19.3076",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65281 10.7736C1.6613 12.0479 2.02441 13.3627 2.57405 14.4241V14.4314C2.97119 15.2022 3.51396 15.8111 4.13217 16.4144L7.866 15.052C7.15958 14.6932 7.05179 14.4733 6.5454 14.0721C6.02792 13.5502 5.64224 12.9512 5.40205 12.2488H5.39237L5.40205 12.2415C5.24403 11.7776 5.22844 11.2853 5.22261 10.7736H1.65281Z",
    fill: "url(#paint0_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94101 2.65641C9.57196 3.95294 9.71307 5.21321 9.94101 5.94649C10.3672 5.94681 10.7777 5.99761 11.167 6.09881C12.0594 6.33082 12.6906 6.78778 13.0774 7.14922L15.4711 4.80514C14.0531 3.50497 12.3465 2.65846 9.94101 2.65641Z",
    fill: "url(#paint1_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93301 2.6486C8.1228 2.64856 6.45154 3.21257 5.08199 4.16577C4.57348 4.51969 4.10683 4.92853 3.6913 5.38317C3.58245 6.40441 4.50618 7.65962 6.33547 7.64923C7.22302 6.6168 8.5357 5.94882 9.99672 5.94882C9.99805 5.94882 9.99935 5.94892 10.0007 5.94893L9.94101 2.64883C9.93832 2.64883 9.9357 2.6486 9.93301 2.6486Z",
    fill: "url(#paint2_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9077 11.1386L14.292 12.2486C14.2211 12.6839 14.0618 13.1121 13.8286 13.5026C13.5615 13.9499 13.2313 14.2905 12.8928 14.5499C11.881 15.3252 10.7021 15.4849 9.88134 15.4855C9.03305 16.9303 8.88433 17.654 9.94101 18.8201C11.2485 18.8191 12.4077 18.5831 13.4302 18.1411C14.1693 17.8216 14.8241 17.4049 15.417 16.8693C16.2004 16.1616 16.8141 15.2863 17.2328 14.2792C17.6516 13.2721 17.8755 12.1333 17.8755 10.8986L15.9077 11.1386Z",
    fill: "url(#paint3_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    filter: "url(#filter4_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82168 9.11735V12.4268H17.5954C17.6637 11.9736 17.8899 11.3871 17.8899 10.9015C17.8899 10.3341 17.8329 9.64107 17.7363 9.11735H9.82168Z",
    fill: "#3086FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter5_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72839 5.26579C3.24868 5.79066 2.83885 6.37815 2.51391 7.01351C1.95643 8.10011 1.65118 9.42112 1.65118 10.7158C1.65118 10.7341 1.65269 10.7519 1.65281 10.7701C1.8997 11.2435 5.06316 11.1529 5.22261 10.7701C5.22241 10.7523 5.2204 10.7349 5.2204 10.717C5.2204 10.1859 5.31011 9.79453 5.47364 9.31444C5.67537 8.72226 5.99124 8.17694 6.39514 7.7071C6.4867 7.59021 6.73093 7.33891 6.80218 7.18818C6.82932 7.13076 6.7529 7.09854 6.74863 7.07833C6.74385 7.05573 6.64139 7.0739 6.61844 7.05707C6.54556 7.00361 6.40123 6.97569 6.31359 6.95088C6.12628 6.89784 5.81584 6.78088 5.64342 6.65963C5.09839 6.27638 4.24782 5.81858 3.72839 5.26579Z",
    fill: "url(#paint4_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter6_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65513 7.08301C6.919 7.84861 7.28247 6.69658 8.12277 6.33608L6.66104 3.30485C6.12334 3.53085 5.61531 3.81163 5.14395 4.13969C4.44 4.62964 3.81836 5.22751 3.30485 5.90789L5.65513 7.08301Z",
    fill: "url(#paint5_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    filter: "url(#filter7_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16952 14.8185C4.47294 15.431 4.20733 15.4529 4.05116 16.5044C4.34959 16.7956 4.67024 17.065 5.01097 17.3092C5.92526 17.9646 7.68397 18.8375 9.9332 18.8375C9.93584 18.8375 9.93837 18.8373 9.94101 18.8373V15.4323C9.9393 15.4323 9.93735 15.4324 9.93564 15.4324C9.09339 15.4324 8.42034 15.2112 7.73026 14.8265C7.56011 14.7316 7.25142 14.9863 7.09451 14.8725C6.87808 14.7154 6.35723 15.0078 6.16952 14.8185Z",
    fill: "url(#paint6_radial_0_13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    opacity: 0.5,
    filter: "url(#filter8_f_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94741 15.3205V18.7737C9.26212 18.8106 9.58963 18.8329 9.93321 18.8329C10.2776 18.8329 10.6108 18.8152 10.9346 18.7827V15.3438C10.5718 15.4058 10.23 15.4278 9.93566 15.4278C9.59661 15.4278 9.26689 15.3884 8.94741 15.3205Z",
    fill: "url(#paint7_linear_0_13)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_13",
    x: 1.18273,
    y: 10.3035,
    width: 7.15335,
    height: 6.58094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_13",
    x: 9.24401,
    y: 2.18633,
    width: 6.69717,
    height: 5.43296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_13",
    x: 3.2126,
    y: 2.17852,
    width: 7.25816,
    height: 5.94085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_13",
    x: 8.72634,
    y: 10.4285,
    width: 9.61928,
    height: 8.86165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_0_13",
    x: 9.3516,
    y: 8.64727,
    width: 9.00834,
    height: 4.24962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_0_13",
    x: 1.1811,
    y: 4.79571,
    width: 6.09698,
    height: 6.76644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_0_13",
    x: 0,
    y: 0,
    width: 11.4276,
    height: 10.6452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65243,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_0_13",
    x: 3.58108,
    y: 14.3348,
    width: 6.83001,
    height: 4.9728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_0_13",
    x: 8.47733,
    y: 14.8504,
    width: 2.92737,
    height: 4.45261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_0_13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.332481 -7.96794 11.9541 -0.478149 7.79125 16.2943)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.64645 -1.35704e-05 -7.93631e-06 7.13951 15.2472 6.97961)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.91108 4.28995 5.94584 10.5107 12.1636 1.61513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.347 -18.3365 -6.9131 5.18501 10.0586 17.7846)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.0153 8.56811 12.1001 1.37445 9.23991 4.15921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.93475 3.17785 -9.15481 -8.1044 7.81213 4.07275)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_0_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.91108 -4.28994 5.94584 -10.5106 12.1636 19.8223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_13",
    x1: 8.94741,
    y1: 17.0767,
    x2: 10.9346,
    y2: 17.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-symbol.46fd2403b4c661e0e88d5f9f2a2e3f23.svg";